import { isReference } from '@medplum/core'
import type { Patient, Reference } from '@medplum/fhirtypes'
import { referenceDisplay } from '@seen/core/display'
import { Participant } from '@seen/core/models/patients/participant'
import type { JSX } from 'react'
import { ResourceCard } from '#src/components/core/ResourceCard.tsx'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export interface ParticipantNameProps {
  participant: Participant | Reference<Patient> | undefined
}

export function ParticipantName({
  participant,
}: ParticipantNameProps): JSX.Element {
  const { data } = useRead(
    Participant,
    isReference(participant) ? participant : undefined
  )
  const instance = participant instanceof Participant ? participant : data

  const reference =
    participant instanceof Participant ? participant.reference : participant

  return (
    <Tooltip>
      <TooltipTrigger tabIndex={-1}>
        <span className="overflow-hidden text-nowrap text-ellipsis decoration-1 underline-offset-[2.5px] hover:underline">
          {instance?.name ?? referenceDisplay(reference)}
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        {reference && <ResourceCard value={reference} />}
      </TooltipContent>
    </Tooltip>
  )
}
